import { Pipe, PipeTransform } from '@angular/core';
import { WindowRef } from '@spartacus/core';

@Pipe({
  name: 'stripHtml',
  standalone: false,
})
export class StripHtmlPipe implements PipeTransform {
  constructor(protected winRef: WindowRef) {}

  transform(html: string) {
    const elem = this.winRef.document.createElement('div');
    elem.innerHTML = html?.replace(/<br\/?>/g, '\n');
    return elem.textContent;
  }
}
